import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-model-dropdown',
  templateUrl: './ModelDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => ModelDropdownComponent)}]
})
export class ModelDropdownComponent extends BaseDropdownComponent {

    
    models: ent.Model[] = [];
    public filter: filters.ModelFilter;

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
        this.filter = new filters.ModelFilter();
    }


    ngOnInit(): void {
    }

    public load(){
        this.domainDataService.getModels(this.filter).subscribe(x=> this.onGetModelsDone(x));
    }

    public loadOnDemand(){

        this.domainDataService.getModels(this.filter).subscribe(x=> this.onGetModelsDone(x));
    }
    
    onGetModelsDone(items: ent.Model[]){
        this.selectItems = [];
        this.models = [];
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        items.forEach(y=> this.models.push(y));
        this.value = this.selectedID;
    }

}